export default __webpack_public_path__ + "static/media/scrollRight7.f702a93d.jpg";